/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface BulkRemoveFolderDocumentsRequest
 */
export interface BulkRemoveFolderDocumentsRequest {
  /**
   * フォルダから解除する資料IDリスト
   * @type {Array<string>}
   * @memberof BulkRemoveFolderDocumentsRequest
   */
  ids: Array<string>
}

export function BulkRemoveFolderDocumentsRequestFromJSON(json: any): BulkRemoveFolderDocumentsRequest {
  return BulkRemoveFolderDocumentsRequestFromJSONTyped(json, false)
}

export function BulkRemoveFolderDocumentsRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): BulkRemoveFolderDocumentsRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    ids: json['ids']
  }
}

export function BulkRemoveFolderDocumentsRequestToJSON(value?: BulkRemoveFolderDocumentsRequest | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    ids: value.ids
  }
}
